/**
 * 도입 / 제휴 문의 모달 (template-parts/inquiry-modal.php).
 *
 * 헤더의 [도입 / 제휴 문의] 버튼이 여는 일은 initModal.js 가 한다. 여기서는 입력을 확인하고
 * admin-ajax(Inquiry::handle_submit)로 보낸다. 첨부는 공통 파일 첨부(attachfield)가 input.files 에
 * 넣어 두므로 FormData(form) 그대로 보내면 된다.
 *
 * 보내는 동안 모달을 잠그고(lockModal — [등록] "등록 중…" · 닫기 막음), 접수되면 폼을 비우고 닫은 뒤
 * 알림(toast)을 띄운다. 실패하면 잠금을 풀고 footer 안내(.notice)에 이유를 적는다.
 */

import { lockModal } from './initModal';
import { postForm, setNotice, showToast } from './partnerForm';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^0\d{8,10}$/;

const InitInquiry = () => {
  const form = document.querySelector('[data-inquiry-form]');

  if (!form) {
    return;
  }

  const dialog = form.closest('dialog');
  const status = dialog?.querySelector('[data-inquiry-status]');
  const submit = dialog?.querySelector(`[type="submit"][form="${form.getAttribute('id')}"]`);

  const setStatus = (message, state = 'error') => setNotice(status, message, state);
  const field = (name) => form.elements.namedItem(name);
  const value = (name) => {
    const element = field(name);

    return element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement
      ? element.value.trim()
      : '';
  };

  // 다른 화면에서 분류 · 제목을 정해 여는 버튼(data-inquiry-preset) — 예: 나의 정보 [변경 요청].
  // 여는 일은 initModal.js 가 같은 클릭으로 한다. 제목은 비어 있을 때만 채워 적던 글을 덮지 않는다.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-inquiry-preset]');

    if (!trigger) {
      return;
    }

    const category = form.querySelector(
      `input[name="category"][value="${trigger.dataset.inquiryCategory || ''}"]`
    );

    if (category) {
      category.checked = true;
    }

    const title = field('title');

    if (
      title instanceof HTMLInputElement &&
      '' === title.value.trim() &&
      trigger.dataset.inquiryTitle
    ) {
      title.value = trigger.dataset.inquiryTitle;
    }
  });

  // 고치기 시작하면 지난번 안내는 걷어 낸다
  form.addEventListener('input', () => setStatus(''));
  form.addEventListener('change', () => setStatus(''));

  // 첨부 한도를 넘긴 파일은 attachfield 가 빼고 알려 온다
  form.addEventListener('attachfield:error', (event) => setStatus(event.detail?.message || ''));

  /** 비었거나 형식이 틀린 첫 칸 — 없으면 null */
  const findProblem = () => {
    if ('' === value('name')) {
      return { message: '이름을 입력해 주세요.', focus: field('name') };
    }

    // 데모 계정은 휴대전화가 선택이다(data-phone-optional) — 적었다면 형식은 본다
    const phone = value('phone').replace(/\D/g, '');

    if (('' !== phone || !form.hasAttribute('data-phone-optional')) && !PHONE_PATTERN.test(phone)) {
      return {
        message: '휴대전화 번호를 01012345678 형식(숫자만)으로 입력해 주세요.',
        focus: field('phone'),
      };
    }

    if (!EMAIL_PATTERN.test(value('email'))) {
      return { message: '이메일 주소를 확인해 주세요.', focus: field('email') };
    }

    if (!form.querySelector('input[name="category"]:checked')) {
      return {
        message: '문의 분류를 골라 주세요.',
        focus: form.querySelector('input[name="category"]'),
      };
    }

    if ('' === value('title')) {
      return { message: '문의 제목을 입력해 주세요.', focus: field('title') };
    }

    if ('' === value('content')) {
      return { message: '문의 내용을 입력해 주세요.', focus: field('content') };
    }

    return null;
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const problem = findProblem();

    if (problem) {
      setStatus(problem.message);
      problem.focus?.focus();
      return;
    }

    setStatus('');

    const unlock = lockModal(dialog, submit, '등록 중…');

    try {
      const result = await postForm(form, form.dataset.action || '', new FormData(form));

      unlock();
      form.reset();
      dialog?.close();
      showToast(result.message || '문의가 접수되었습니다.');
    } catch (error) {
      unlock();
      setStatus(error.message);
    }
  });
};

export default InitInquiry;
